<div [class.reply]="isReply" class="w-100 chatPanel">
    @if (!initialCommentData && currentUser) {
        <div [appUserAvatar]="currentUser" class="miniInitial bg-primary m-15"
             mat-card-avatar>
            <span class="primary-text">{{ currentUser?.username | slice: 0 : 1 | titlecase }}</span>
        </div>
    }
    <div class="contentColumn">
        <!--            <mat-form-field appearance="outline" class="whiteField noBottomPadding" color="primary" [class.closedState]="!isOpenState">-->
        <!--                <textarea matInput maxlength="400" [formControl]="comment" [placeholder]="placeholder" [rows]="isOpenState ? 3 : 1" (focus)="setState(true)"></textarea>-->
        <!--            </mat-form-field>-->
        <div class="d-flex flex-row w-100 gap-10 mobileReverseColumn z-index-2">
            <div class="flex-auto w-100">
                @if (!community?.disable_comment_typing_animation) {
                    <app-typing-indicator [postId]="post?.id"></app-typing-indicator>
                }
                <mat-form-field [class.closedState]="!isOpenState" appearance="outline"
                                class="whiteField w-100 replyField"
                                color="primary">
                    <mat-label>Comment</mat-label>
                    <textarea #replyField (focus)="commentFocus(replyField)" [formControl]="comment"
                              [placeholder]="placeholder"
                              [rows]="isOpenState ? 5 : 1"
                              appResizableIframe
                              class="textAreaResize "
                              matInput required></textarea>
                    <ngx-mentions [textInputElement]="replyField"
                                  [menuTemplate]="menuTemplate"
                                  [mentionsConfig]="mentionsConfig"
                                  [selectedChoices]="selectedUsers"
                                  [searchRegexp]="searchRegexp"
                                  [removeWholeTagOnBackspace]="true"
                                  [mentions]="mentions"
                                  (search)="loadChoices($event)"
                                  (selectedChoicesChange)="onSelectedChoicesChange($event)"></ngx-mentions>
                    <ng-template #menuTemplate
                                 let-selectChoice="selectChoice">
                        <ngx-text-input-autocomplete-menu [choices]="choices"
                                                          [getDisplayLabel]="getDisplayLabel"
                                                          (selectChoice)="selectChoice($event)">
                        </ngx-text-input-autocomplete-menu>
                    </ng-template>
                </mat-form-field>
                @if (isOpenState && hasCommunityRole(['member'])) {
                    <mat-checkbox [(ngModel)]="is_anonymous">Comment
                        Anonymously
                    </mat-checkbox>
                }
                @if (isOpenState && (this.isSuperuser || this.hasCommunityRole(['full_admin'])) && !initialCommentData) {
                    <mat-form-field appearance="outline" class="whiteField w-100 z-index-less"
                                    color="primary">
                        <mat-label>Comment as</mat-label>
                        <input [formControl]="userSearchControl"
                               [matAutocomplete]="auto"
                               matInput placeholder="Select User">
                        <mat-autocomplete #auto="matAutocomplete"
                                          (optionSelected)="selectUser($event.option.value)">
                            @for (user of filteredUsers; track user) {
                                <mat-option [value]="user">
                                    {{ user.username }}
                                </mat-option>
                            }
                        </mat-autocomplete>
                        @if (loadingUsers) {
                            <mat-icon matSuffix>
                                <mat-spinner color="primary"></mat-spinner>
                            </mat-icon>
                        }
                    </mat-form-field>
                }
                @if (commentAsUser) {
                    <mat-chip-set>
                        <mat-chip (removed)="this.commentAsUser = undefined"
                                  class="smChip">
                            {{ commentAsUser.username }}
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip>
                    </mat-chip-set>
                }
            </div>
            @if (isOpenState) {
                <div class="flex-col mobileRow">
                    @if (post?.emoji_enabled && this.selectedCommunity?.emoji_enabled) {
                        <app-emoji-menu
                                [formControl]="comment" [htmlInput]="replyField" matSuffix
                                ngDefaultControl></app-emoji-menu>
                    }
                    <button mat-icon-button color="accent" class="font-20" [matTooltip]="'Mention a user'"
                            (click)="startMention()">
                        &#64;
                    </button>
                </div>
            }

        </div>
        <div class="flex-row flex-space-between gap-10 mt-10 mobileCol z-index-1">
            @if (!hideAttachments) {
                <app-attachments
                        (isValid)="attachmentsValidEmitter($event); this.authService.refreshUser();"
                        (submitField)="getAttachmentField($event)"
                        [attachmentOptions]="['text', 'image', 'video', 'audio', 'videoLink', 'screenRecording', 'url','doc', 'gif', 'survey_url', 'poll', 'heatmap']"
                        [class.addMargin]="post?.emoji_enabled"
                        [class.no-visible]="!isOpenState"
                        [comment]="true"
                        [attachmentButtonText]="post?.effective_attachment_button_text || post?.attachment_button_text"
                        [initialAttachment]="initialCommentDataAttachment"
                        [disableCarousel]="true"
                        [reply]="true"
                        [small]="true"
                        class="commentAttachment"
                ></app-attachments>
            }
            @if (isOpenState) {
                <div class="flex-row flex-end gap-10">
                    <button (click)="reset()" color="warn" mat-raised-button>
                        Cancel
                    </button>
                    <div [matTooltip]="(!attachment && !comment.value) || !attachmentsValid? 'Message or attachment required' :null">
                        <button (click)="!initialCommentData ? submitComment() : patchComment()"
                                (mouseenter)="validate(comment)"
                                [disabled]="sending || (!attachment && !comment.value && !initialCommentDataAttachment) || !attachmentsValid"
                                color="accent"
                                mat-raised-button>
                            @if (initialCommentData) {
                                Update comment
                            }
                            @if (!isReply && !initialCommentData) {
                                Submit
                            }
                            @if (isReply && !initialCommentData) {
                                Reply
                            }
                            @if (sending) {
                                <mat-icon>
                                    <mat-spinner color="accent"></mat-spinner>
                                </mat-icon>
                            }
                        </button>
                    </div>
                </div>
            }
        </div>
        @if (sending) {
            <div class="w-100 d-flex pb-15 flex-col align-items-center gap-10">
                <div role="status" aria-live="polite">{{ uploadProgress !== null && uploadProgress! < 100 ? 'Uploading attachments: ' + uploadProgress + '%' : 'Saving comment…' }}</div>
                <mat-progress-bar class="pb-10" aria-label="Comment upload progress"
                                  [mode]="uploadProgress !== null && uploadProgress! < 100 ? 'determinate' : 'indeterminate'"
                                  [value]="uploadProgress ?? 0"></mat-progress-bar>
            </div>
        }
    </div>
</div>
